import { Heading } from 'rebass'
import styled from 'styled-components'
import media from './Media'

const Title = styled(Heading)`
  font-size: 48px;
  line-height: 1;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  font-weight: normal;

  ${props => props.inverted && `transform: scaleX(-1); pointer-events: none;`}

  ${media.desktop`
    font-size: 64px;
  `}
`
export default Title
